/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import algoQuestions from 'images/coin-pages/questions/algo.svg'

import { commonSlidesData } from '../commonPageData'

export const algoPage: ICoinPageData = {
  title: 'coin_50',
  description: 'coin_51',
  // description: 'coin_52',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Algorand' }) }} />
  ),
  questionsBlock: {
    image: algoQuestions,
    questions: [
      {
        title: 'coin_53',
        answer: 'coin_54',
      },
      {
        title: 'coin_55',
        answer: 'coin_56',
      },
      {
        title: 'coin_57',
        answer: 'coin_58',
      },
      {
        title: 'coin_59',
        answer: 'coin_60',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Algorand (ALGO)'),
    text: [],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/whats-crypto-collateral-how-collateral-works/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/03/29486.png',
        imageAlt: 'What’s Crypto Collateral? How Collateral Works?',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-market-cap-why-learn-it-before-taking-crypto-loan/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1146/https://coinrabbit.io/blog/wp-content/uploads/2021/07/Screenshot_95656.png',
        imageAlt: 'Crypto Market Cap. Why Learn It before Taking Crypto Loan?',
      },
      {
        link:
          'https://coinrabbit.io/blog/do-e-commerce-sites-accept-crypto-how-to-spend-a-crypto-loan-on-the-internet/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_900/https://coinrabbit.io/blog/wp-content/uploads/2021/06/CR-Ecommerce-1.jpg',
        imageAlt: 'How to use crypto loans in e-commerce?',
      },
    ],
    paragraphs: [
      {
        title: 'coin_61',
        text: ['coin_63', 'coin_64'],
      },
      {
        title: 'coin_62',
        text: ['coin_65'],
      },
    ],
  },
}
